import { PaginatedTable } from "@commonlibs";
import clsx from "clsx";
import { useTheme } from "styled-components";
import { DataTableRoot } from "./DataTable.styles";
import { DataTableProps } from "./DataTable.types";
import TableActions from "./TableActions/TableActions";
import NothingToShow from "../../feedback/NothingToShow/NothingToShow";

const DataTable = ({
    data,
    isLoading,
    title,
    search,
    onAddItem,
    textAddItem,
    onExport,
    onRedeemPoints,
    onInviteUser,
    style,
    className,
    noRowsElement = <NothingToShow />,
    onRefresh,
    refreshing,
    dateRangeFilter,
    ...rest
}: DataTableProps) => {
    const { spacing } = useTheme();
    const nothingToShow = !isLoading && data?.length === 0;

    return (
        <DataTableRoot className={clsx("data-table", className)} style={style} gap={spacing[6]} flex={1}>
            <TableActions
                onRefresh={onRefresh}
                nothingToShow={nothingToShow}
                title={title}
                search={search}
                onAddItem={onAddItem}
                textAddItem={textAddItem}
                onExport={onExport}
                onRedeemPoints={onRedeemPoints}
                onInviteUser={onInviteUser}
                refreshing={refreshing}
                dateRangeFilter={dateRangeFilter}
                {...rest}
            />
            {nothingToShow ? (
                noRowsElement
            ) : (
                <PaginatedTable {...rest} style={{ flex: "1", justifyContent: "space-between" }} loading={isLoading} data={data || []} />
            )}
        </DataTableRoot>
    );
};

export default DataTable;
